import { t, ui } from '../i18n';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  AccountTree as BlockExplorerIcon,
  Monitor as MonitorIcon,
  SwapHoriz as TransactionIcon,
  Login as AccessLogIcon
} from '@mui/icons-material';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
    { text: 'Node Management', icon: <GroupIcon />, path: '/nodes' },
    { text: 'Block Explorer', icon: <BlockExplorerIcon />, path: '/blocks' },
    { text: 'Transaction Tracking', icon: <TransactionIcon />, path: '/transactions' },
    { text: 'System Monitor', icon: <MonitorIcon />, path: '/monitor' },
    { text: 'Access Logs', icon: <AccessLogIcon />, path: '/access-logs' },
  ];

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          marginTop: 8,
        },
      }}
    >
      <Box sx={{ padding: 2 }}>
        <Typography variant="caption" color="textSecondary">{t("Blockchain Management")}</Typography>
      </Box>
      
      <Divider />
      
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              onClick={() => navigate(item.path)}
              selected={location.pathname === item.path}
            >
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={ui(item.text)} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
